const userState = {
	list: [],
	filter: null
};

module.exports = function userReducer(state = userState, {payload, type}) {
	switch (type) {
		case "CREATE_USER_SUCCESS":
			return Object.assign(
				{}, state, state.list.push(payload)
			);

		case "LOAD_USERS_SUCCESS":
			return Object.assign(
				{}, state, { list: payload}
			);

		case "FILTER_USERS":
			return Object.assign(
				{}, state, { filter: payload }
			);

		case "UPDATE_USER_SUCCESS":
			return Object.assign(
				{}, state, { list: state.list.map(user => { 
					return user.id === payload.id ? payload : user
				})}
			);

		case "DELETE_USER_SUCCESS":
			return Object.assign(
				{}, state, { list: state.list.filter(user => user.id !== payload.id) }
			)

		case "UNLOAD_USERS":
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/user.js